import { useEffect, useState } from "react";
import {
    ROUTE_ADD_BUILDING,
    ROUTE_EDIT_BUILDING,
    ROUTE_MANAGE_BUILDING_DATA
} from "../../routes/Routes";
import GetFetch from "../../hooks/GetFetch";
import usePageTitle from "../../hooks/usePageTitle";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import ListViewConfig from "../../ListViewConfig/ListViewConfig";
import "./Buildings.scss";

const Buildings = () => {
    const [dataSource, setDataSource] = useState([]);
    const [allowEditing, setAllowEditing] = useState(false);
    const [allowCreate, setAllowCreate] = useState(false);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();
    const navigate = useNavigate();
    const { module, title } = ROUTE_MANAGE_BUILDING_DATA;
    const routeModule = module;

    usePageTitle(title);

    useEffect(() => {
        getBuildingData();

        const permissions = user.role.ModulePermissions?.filter(module => {
            return (module.Page == routeModule)
        });

        setAllowEditing(permissions?.filter(module => {
            return (module.Update)
        }).length > 0);

        setAllowCreate(permissions?.filter(module => {
            return (module.Create)
        }).length > 0);
    }, []);

    const getBuildingData = async () => {
        setLoading(true);
        const { Errors, Message, Success } = await GetFetch("/v1/Building");

        if (Success)
            setDataSource(Message.map(
                (
                    {
                        SequenceNumber,
                        BuildingId,
                        Name,
                        Facility,
                        Status,
                        RegionNumber,
                        Location: {
                            Address1,
                            Address2,
                            CityName,
                            State,
                            ZipCode
                        },
                        RentUsageFactor,
                        AdjustedRentSqFt,
                        AdjustedUsageSqFt,
                        AnsiRentSqFt,
                        AnsiUsableSqFt,
                        JointUseSqFt,
                        CommunityJointUseSqFt,
                        LeaseJointUseSqFt,
                        CongressionalRep,
                        Version
                    }
                ) => {
                    return {
                        SequenceNumber,
                        BuildingId,
                        Name,
                        Status,
                        Facility,
                        RegionNumber,
                        Address: `
                            ${Address1 ? Address1 : ""},
                            ${Address2 !== "" ? " " + Address2 + "," : ""} 
                            ${CityName ? CityName : ""}, 
                            ${State ? State : ""} 
                            ${ZipCode ? ZipCode.replace(/(\d{5})(\d{4})/, '$1-$2') : ""}`,
                        RentUsageFactor: RentUsageFactor.toFixed(2),
                        AdjustedRentSqFt,
                        AdjustedUsageSqFt,
                        AnsiRentSqFt,
                        AnsiUsableSqFt,
                        JointUseSqFt,
                        CommunityJointUseSqFt,
                        LeaseJointUseSqFt,
                        CongressionalRep,
                        Version
                    };
                }
            ));

        if (Errors.length > 0)
            console.error(Errors);

        setLoading(false);
    };

    const routeToEditBuildingModule = ({ data }) => {
        navigate(
            ROUTE_EDIT_BUILDING.withSlash,
            { state: { data } }
        );
    };

    const handleKeyDown = (keyValue, e) => {
        if (keyValue.keyCode !== 13) return;

        if (keyValue.keyCode === 13) {
            keyValue.preventDefault();
            routeToEditBuildingModule(e);
        };
    };

    const childProps = {
        addRecordText: "Add A New Building",
        addRecordHandler: () => navigate(ROUTE_ADD_BUILDING.withSlash),

        columns: [
            {
                caption: "Building Number",
                cellRender: (e) => {
                    return (
                        allowEditing ?
                            <button
                                className="inline__span--edit-label"
                                href="#"
                                onClick={() => routeToEditBuildingModule(e)}
                                onKeyDown={keyValue => handleKeyDown(keyValue, e)}
                                style={{
                                    background: 'none',
                                    color: '#1F476B',
                                    border: 'none',
                                    textDecoration: 'underline',
                                    fontWeight: '700',
                                    fontSize: 'inherit',
                                    padding: '0',
                                    cursor: 'pointer'
                                }}

                            >
                                {`Edit: ${e.data.SequenceNumber}`}
                            </button>
                            :
                            <span> {e.data.SequenceNumber} </span>
                    );
                },
                dataField: "SequenceNumber"
            },
            {
                caption: "Name",
                dataField: "Name"
            },
            {
                caption: "Status",
                dataField: "Status"
            },
            {
                caption: "Facility",
                dataField: "Facility"
            },
            {
                caption: "Region",
                dataField: "RegionNumber"
            },
            {
                caption: "Address",
                dataField: "Address"
            },
            {
                caption: "Rent Usage Factor",
                dataField: "RentUsageFactor"
            },
            {
                caption: "Adjusted Rent Sq. Ft.",
                dataField: "AdjustedRentSqFt"
            },
            {
                caption: "Adjusted Usage Sq. Ft.",
                dataField: "AdjustedUsageSqFt"
            },
            {
                caption: "Ansi Rent Sq. Ft.",
                dataField: "AnsiRentSqFt"
            },
            {
                caption: "Ansi Usable Sq. Ft.",
                dataField: "AnsiUsableSqFt"
            },
            {
                caption: "Joint Use Sq. Ft.",
                dataField: "JointUseSqFt"
            },
            {
                caption: "Community Joint Use Sq. Ft.",
                dataField: "CommunityJointUseSqFt"
            },
            {
                caption: "Lease Joint Use Sq. Ft.",
                dataField: "LeaseJointUseSqFt"
            },
            {
                caption: "Congressional Representative",
                dataField: "CongressionalRep"
            }
        ],
        dataSource,
        isChild: false,
        keyExpr: "BuildingId",
        loadingIndicatorState: loading,
        loadingIndicatorLocationId: "List-View",
        loadingIndicatorMessage: `Loading ${title}. Please wait...`,
        masterDetailEnabled: false,
        permissions: {
            allowEditing,
            allowCreate
        },
        showSearchPanel: true,
        showToolBar: true,
        title
    };

    return <ListViewConfig {...childProps} />
};

export default Buildings;